export default { sha: '9d101f7ff3a350e7a5cd497b212c66d4a64ca017', buildNumber: 'undefined' }
